import { render, staticRenderFns } from "./peopleAnjianTemplateDesc.vue?vue&type=template&id=246d8bdd&scoped=true"
import script from "./peopleAnjianTemplateDesc.vue?vue&type=script&lang=js"
export * from "./peopleAnjianTemplateDesc.vue?vue&type=script&lang=js"
import style0 from "./peopleAnjianTemplateDesc.vue?vue&type=style&index=0&id=246d8bdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d8bdd",
  null
  
)

export default component.exports